import { Moment } from 'moment';
import { ModelBase } from '../abstract/model-base.model';
import { Currency } from '../core/currency.model';
import { LedgerEntry } from './ledger-entry.model';
import { CurrenciesEnum } from '../../enums/currencies.enum';
import { AutoMatchingRuleEnum } from '../../enums/auto-matching-rule.enum';

export class Settlement extends ModelBase {

    static override CLASS_NAME: string = 'Settlement';

    private _application!: LedgerEntry;
    private _applicationAmount!: number;
    private _applicationAmountOrg!: number;
    private _applicationCurrency!: Currency;
    private _autoCreated!: boolean;
    private _autoRule!: AutoMatchingRuleEnum | null;
    private _automatic!: boolean;
    private _cancelled!: boolean;
    private _changeDiscrepancy!: number;
    private _currency!: Currency;
    private _date!: Moment;
    private _groupOnly!: boolean;
    private _obligation!: LedgerEntry;
    private _obligationAmount!: number;
    private _obligationAmountOrg!: number;
    private _obligationCurrency!: Currency;

    constructor(data: any) {
        super(data);
    }

    public get application(): LedgerEntry {
        return this._application;
    }

    public set application(value: any) {
        this._setValue('_application', value, 'LedgerEntry');
    }

    public get applicationAmount(): number {
        return this._applicationAmount;
    }

    public set applicationAmount(value: any) {
        this._setValue('_applicationAmount', value, 'float');
    }

    public get applicationAmountOrg(): number {
        return this._applicationAmountOrg;
    }

    public set applicationAmountOrg(value: any) {
        this._setValue('_applicationAmountOrg', value, 'float');
    }

    public get applicationCurrency(): Currency {
        return this._applicationCurrency;
    }

    public set applicationCurrency(value: any) {
        this._setValue('_applicationCurrency', value, 'Currency');
    }

    public get autoCreated(): boolean {
        return this._autoCreated;
    }

    public set autoCreated(value: any) {
        this._setValue('_autoCreated', value, 'boolean');
    }

    public get autoRule(): AutoMatchingRuleEnum | null {
        return this._autoRule;
    }

    public set autoRule(value: any) {
        this._setValue('_autoRule', value, 'string');
    }

    public get automatic(): boolean {
        return this._automatic;
    }

    public set automatic(value: any) {
        this._setValue('_automatic', value, 'boolean');
    }

    public get cancelled(): boolean {
        return this._cancelled;
    }

    public set cancelled(value: any) {
        this._setValue('_cancelled', value, 'boolean');
    }

    public get changeDiscrepancy(): number {
        return this._changeDiscrepancy;
    }

    public set changeDiscrepancy(value: any) {
        this._setValue('_changeDiscrepancy', value, 'float');
    }

    public get currency(): Currency {
        return this._currency;
    }

    public set currency(value: any) {
        this._setValue('_currency', value, 'Currency');
    }

    public get date(): Moment {
        return this._date;
    }

    public set date(value: any) {
        this._setValue('_date', value, 'date');
    }

    public get fixedExchangeRate(): boolean {
        return (
            this.applicationCurrency.code === this.obligationCurrency.code ||
            this.applicationCurrency.code === CurrenciesEnum.Eur && this.obligationCurrency.code === CurrenciesEnum.Xpf ||
            this.applicationCurrency.code === CurrenciesEnum.Xpf && this.obligationCurrency.code === CurrenciesEnum.Eur
        );
    }

    public set fixedExchangeRate(value: any) {
        this._setValue('_fixedExchangeRate', value, 'boolean');
    }

    public get groupOnly(): boolean {
        return this._groupOnly;
    }

    public set groupOnly(value: any) {
        this._setValue('_groupOnly', value, 'boolean');
    }

    public get obligation(): LedgerEntry {
        return this._obligation;
    }

    public set obligation(value: any) {
        this._setValue('_obligation', value, 'LedgerEntry');
    }

    public get obligationAmount(): number {
        return this._obligationAmount;
    }

    public set obligationAmount(value: any) {
        this._setValue('_obligationAmount', value, 'float');
        if (this.loaded) {
            this._calculateApplicationAmount();
            this._calculateObligationAmountOrg();
        }
    }

    public get obligationAmountOrg(): number {
        return this._obligationAmountOrg;
    }

    public set obligationAmountOrg(value: any) {
        this._setValue('_obligationAmountOrg', value, 'float');
    }

    public get obligationCurrency(): Currency {
        return this._obligationCurrency;
    }

    public set obligationCurrency(value: any) {
        this._setValue('_obligationCurrency', value, 'Currency');
    }

    private _calculateApplicationAmount(): void {
        // Étape 1, conversion du montant de l'obligation en devise interne
        const obligationAmountInInternalCurrency = this.obligationAmount * this.obligation.exchangeRate;
        // Étape 2, conversion du montant interne en devise d'application
        this.applicationAmount = obligationAmountInInternalCurrency / this.application.exchangeRate;
    }

    private _calculateObligationAmountOrg(): void {
        this.obligationAmountOrg = this.obligationAmount * this.obligation.exchangeRate;
    }
}